<template>
    <div class="performance">
        <span class="performance__date-time">
            <span class="performance__date">{{ format(props.performance.startDate, 'dd/MM/yyyy') }}</span>
            <span class="performance__time">{{ format(props.performance.startDate, 'HH:mm') }}</span>
        </span>
        <span class="performance__venue">{{ props.performance.event.venue?.title }}</span>
        <Availability v-if="featureEnabled('performance.availability')" :event="props.performance" />
        <a
            class="
                performance__book-button
                btn
            "
            v-if="props.performance.bookButton?.link && bookable"
            :href="props.performance.bookButton.link"
        >{{ props.performance.bookButton.title }}</a>
        <span
            class="
                btn
                performance__book-button
                performance__book-button--not-bookable
            "
            v-if="!bookable"
        >{{ props.performance.bookButton.title }}</span>
    </div>
</template>

<script setup>
import { format } from 'date-fns';

import Availability from './Availability.vue';
import { computed } from 'vue';
import { isBookable } from '../../services/performance';

const props = defineProps({
    performance: {
        type: Object,
        required: true,
    }
});

const featureEnabled = window.featureEnabled; //Required for access in template

const bookable = computed(() => {
    return isBookable(props.performance);
});
</script>
